{
  "name": "Commodity Category Master",
  "dbName": "commodity_category_master",
  "columns": [
    {
      "fieldName": "name",
      "dbName": "name",
      "displayName": "Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "code",
      "dbName": "code",
      "displayName": "Code",
      "dataType": "STRING",
      "styleConfig": {
        "type": "badge"
      }
    },
    {
      "fieldName": "cargoType",
      "dbName": "cargo_type",
      "displayName": "Cargo Type",
      "dataType": "STRING"
    },
    {
      "fieldName": "highValue",
      "dbName": "high_value",
      "displayName": "High Value",
      "dataType": "BOOLEAN",
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Status",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "createdDate",
      "displayName": "Created Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "createdBy",
      "displayName": "Created By",
      "dataType": "STRING",
      "hasLookup": true,
      "styleConfig": {
        "type": "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "dbName": "modified_at",
      "displayName": "Modified Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    }
  ],
    "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search commodity category by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "category_name"
      }
    ]
  }
}
